import { render, staticRenderFns } from "./MtqrAddMain.vue?vue&type=template&id=12ee98ec&scoped=true&"
import script from "./MtqrAddMain.vue?vue&type=script&lang=js&"
export * from "./MtqrAddMain.vue?vue&type=script&lang=js&"
import style0 from "./MtqrAddMain.vue?vue&type=style&index=0&id=12ee98ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ee98ec",
  null
  
)

export default component.exports